import useModalStore from '../../stores/useModalStore';
import { checkIsMobile } from '../../utils/checkIsMobile';

export const scrollIntoPlayerArea = () => {
  if (checkIsMobile()) return;
  const playerArea = document.getElementById('player-area');
  if (playerArea) {
    useModalStore.getState().clearModals();
    playerArea.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
};
